import {match} from 'ts-pattern';

import {CustomerMessageCallOutcome} from '@dms/api/core';
import i18n from '@dms/i18n';

/**
 * Sentence for a stored call's outcome, shared by the thread call card and the call page. The call
 * list shows the backend's short enum labels instead.
 */
export const getTelephonyCallOutcomeLabel = (outcome: CustomerMessageCallOutcome) =>
  match(outcome)
    .with('connected', () => i18n.t('page.telephony.bar.connected'))
    .with('nobody_answered', () => i18n.t('page.settings.telephony.routingSummaryNoAnswer'))
    .with('caller_hung_up', () => i18n.t('page.telephony.indicator.callerHungUp'))
    .with('customer_not_reached', () => i18n.t('page.telephony.indicator.customerNotReached'))
    .with('bot', () => i18n.t('page.telephony.thread.outcomeBot'))
    .exhaustive();
